import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { bfv_J3 } from "../../../modules/Beräkningsmoduler/BFV_J3";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card } from "react-bootstrap";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J3 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfv_J3().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const funktionsKontroller = bm.funktionsKontroller;

  const systemText = global.beräkningsflikarText.beskr_BFV_J3;

  return (
    <>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Funktionskontroller bfName="BFV_J3" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </>
  );
};

export default BFV_J3;
